import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="bg-background-50" id="categories">
      <div className="mx-auto max-w-content px-4 md:px-8 py-14 md:py-20">
        <div className="mb-8 md:mb-10">
          <p className="text-xs tracking-[0.3em] text-secondary-600 font-label">SECTIONS</p>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            四个栏目，四种现场
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl">
            从直播事故到街头偶遇，把不同场景下的反差分门别类，方便你按兴趣深入阅读。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat, index) => {
            const count = getArticlesByCategory(cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group relative flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 ${
                  index % 2 === 1 ? 'lg:mt-6' : ''
                }`}
              >
                <div className="relative w-full h-40 overflow-hidden bg-background-200">
                  <img
                    src={cat.cover}
                    alt={cat.coverAlt}
                    title={`${cat.name} - 反差现场`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs text-foreground-900 font-label">
                    {count} 篇收录
                  </span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <span className="w-9 h-9 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center mb-3">
                    <i className={`${cat.icon} text-lg leading-none`} aria-hidden="true" />
                  </span>
                  <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">
                    {cat.desc}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-600 font-label">
                    进入栏目
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}